import React from "react"

import '../styles/index.scss'
import '../styles/fonts.scss'

export default function Loading(props){
    return (
        <div className="load-screen">
            <h1 id="site-title">Oculus Weather</h1>
            <br />
            <div id="loading-description">
            {props.error? <h2>I'm sorry! There appears to be a network error. <br/> Please try again another time.</h2> : 
            <h2>Searching for browser geolocation...</h2>
            }
            </div>
        </div>
    )
}
